import React, { useState, useEffect } from 'react';
import HoldingsList from './HoldingsList';
import { useSelector } from 'react-redux';
import ApiClient from '../../utilities/apiClient';
import AppConfig from '../../AppConfig';
import dayjs from 'dayjs';


const HoldingsListController = () => {
  const [holdingData, setHoldingData] = useState();
  const apiToken = useSelector(state => state.auth.apiToken);
  const userId = useSelector(state => state.auth.userId);
  const [showmodal, setShowModal] = React.useState(false);
  const [showlodder, setShowLodder] = React.useState(false);
  const fetchData = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Client.holdings,
        "POST",
        {
          "CLIENT_ID": userId,
          "TO_DATE": dayjs(new Date()).format('DD/MM/YYYY'),
          "PRICELOGIC": 'S',
        })
        .then((response) => {
          console.info(response);
        
          if(response===401){setShowModal(true)}
          if(response && response.Success === "False"){
            setShowLodder(false)
            setHoldingData([])
          }
          if(response && response.Success === "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`data ${responseData}`);
            if (Array.isArray(responseData) && responseData.length > 0) {

              let re=responseData.map(data => {
                return {
                  SCRIP_SYMBOL: data.BSE_SHORT_NAME, // srini - 17/12/24
  
                  NET:data.NET,
                  PURCHASE_PRICE: data.PURCHASE_PRICE,
                  BUYVAL:(data.NET*data.PURCHASE_PRICE).toFixed(4),
                  SCRIP_VALUE:data.SCRIP_VALUE,
                  AMOUNT:data.AMOUNT,
                  PANDL:(data.AMOUNT-(data.NET*data.PURCHASE_PRICE)).toFixed(4),
                  PERCENT_HOLD:data.PERCENT_HOLD,
                  SCRIP_NAME : data.SCRIP_NAME
                }
  
  
              })
              setShowLodder(false)
              setHoldingData(re);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array to fetch data only once on component mount

  return <HoldingsList data={holdingData}
  
  showmodal={showmodal}
  showlodder={showlodder}
  />;
};

export default HoldingsListController;
